import React from "react";
import "./WhyItMatters.css";

const WhyItMatters = () => (
  <section
    id="why-it-matters"
    className="why-it-matters animate-on-scroll"
    aria-labelledby="why-heading"
  >
    <div className="container">
      <h2 id="why-heading">Why It Matters Today</h2>
      <p>
        The Combahee River Collective’s 1977 Statement was one of the first
        to articulate how multiple forms of oppression—race, gender,
        class, sexuality—are interconnected. That framework paved the way for
        modern movements like Black Lives Matter and #MeToo, which explicitly
        invoke intersectionality to ensure no community is left behind.
      </p>
      <p>
        As we navigate conversations around systemic racism and
        LGBTQ+ rights in 2025, the Collective’s insistence that “interlocking
        systems of oppression” be understood as a unified struggle remains
        vital. Their legacy reminds us that lasting social change requires
        centering the most marginalized voices—an enduring lesson for anyone
        coding the past to shape the future.
      </p>
    </div>
  </section>
);

export default WhyItMatters;
